// JsFromRoutes CacheKey 9a9b14b1b7307f94a146074d39fd1145
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/client"

export default {
  sendInvoice: /* #__PURE__ */ definePathHelper(
    "post",
    "/api/:venue_slug/:payable_type/:payable_id/payments/:id/send_invoice"
  ),
  create: /* #__PURE__ */ definePathHelper(
    "post",
    "/api/:venue_slug/:payable_type/:payable_id/payments"
  ),
  destroy: /* #__PURE__ */ definePathHelper(
    "delete",
    "/api/:venue_slug/:payable_type/:payable_id/payments/:id"
  ),
}
